import store from "../store";
import * as types from "../store/header/types";

export function openSnack(title: string, type: types.SnackType) {
  store.dispatch({
    type: types.SHOW_SNACK_TOAST,
    title: title,
    snackType: type
  });
}



// WEBPACK FOOTER //
// ./src/util/util.ts